import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import AssetInwardHistoryChild from "./AssetInwardHistoryChild";

const AssetInwardHistory = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <AssetInwardHistoryChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default AssetInwardHistory;
